//Script to enable functionality to purchase & send gift cards

//Check if gift card price is selected before opening "Send as Gift" modal

let giftCardModalOpener = document.querySelector('.gift_card-button button');
let giftCardATCButton = document.querySelector('[data-product-type="Gift Cards"] [name="add"]')

document.querySelector('.product__info-wrapper product-form [name="id"]').addEventListener("change",function(){
  giftCardModalOpener.removeAttribute("data-disabled")
})

// Trigger add-to-cart button click if there is no variant selected.
// This is to trigger error check.
giftCardModalOpener.addEventListener("click", () => {
  if(giftCardModalOpener.getAttribute("data-disabled") == "true")
    giftCardATCButton.click()
});

// Create relevant product attributes to be passed through when "Send as a gift" is selected

  let giftCardMessageField = document.querySelector('.gift-card-inputs [name="recipent_message"]')
  let recipentEmailField = document.querySelector('.gift-card-inputs [name="recipent_email"]')
  let recipentNameField = document.querySelector('.gift-card-inputs [name="recipent_name"]')
  let giftCardPreviewText = document.querySelector('#gift-card-preview-text')
  let giftCardDesignSelector = document.querySelectorAll('.gift-card-inputs .input-group .design_selector input')

  // Update product form properties depenidng on information entered into "Send as a gift" modal

    recipentNameField.addEventListener("keyup", function(e) {
      recipentName.setAttribute("value", recipentNameField.value)
    })
    
    recipentEmailField.addEventListener("keyup", function(e) {
      recipentEmail.setAttribute("value", recipentEmailField.value)
    })

    giftCardMessageField.addEventListener("keyup", function(e) {
      giftCardPreviewText.textContent = giftCardMessageField.value
      giftCardMessage.setAttribute("value", giftCardMessageField.value)
      if (giftCardMessageField.value == '' || giftCardMessageField.value == '') {
        giftCardPreviewText.textContent = "Gift card message"
      }
    })  

    //Update Gift Card preview image when image is clicked from design options
    giftCardDesignSelector.forEach(element => element.addEventListener("click", function(e){
      document.querySelector('.gift-card-preview > img').src = e.target.closest('label').querySelector('img').src
    }))

  //Append product attrs. to product-form when gift is selected
  let productForm = document.querySelector('.product-form__buy-button form')

  let giftCardMessage = document.createElement("Input")
  giftCardMessage.setAttribute("type", "hidden")
  giftCardMessage.setAttribute("name", "properties[Message]")
  
  let recipentName = document.createElement("Input")
  recipentName.setAttribute("type", "hidden")
  recipentName.setAttribute("name", "properties[Recipient name]")
  
  let recipentEmail = document.createElement("Input")
  recipentEmail.setAttribute("type", "hidden")
  recipentEmail.setAttribute("name", "properties[Recipient email]")
  
  let sendToRecipent = document.createElement("Input")
  sendToRecipent.setAttribute("type", "hidden")
  sendToRecipent.setAttribute("name", 'properties[__shopify_send_gift_card_to_recipient]')
  sendToRecipent.setAttribute("value", "on")

  document.querySelector("#giftCardModalPopup").addEventListener("click", function() {
    productForm.appendChild(giftCardMessage)
    productForm.appendChild(recipentEmail)
    productForm.appendChild(recipentName)
    productForm.appendChild(sendToRecipent)
  })

  // Trigger product add to cart button when modal Add To Cart button is clicked

  sendAsGift = false;

  let addCustomGiftCard = document.querySelector('#add-custom-gift-card')
  var mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;

  addCustomGiftCard.addEventListener("click", function(){
    if (!recipentNameField.value) {
      recipentNameField.style.borderColor = "#D92B44"
    } else if (!recipentEmailField.value || !recipentEmailField.value.match(mailformat)) {
      recipentEmailField.style.borderColor = "#D92B44"
    } else {
      sendAsGift = true
      document.querySelector("#ModalClose-GiftModal").click()
      giftCardATCButton.click()
    } 
  })

  document.addEventListener("ModalClose", function(event) {
    if(!sendAsGift){
      giftCardMessage.remove()
      recipentEmail.remove()
      recipentName.remove()
      sendToRecipent.remove()
    }
  })